/**
 * At Modal
 * This module create or open a lightbox on the page
 * Example:
 *  - Create a modal
 *      <button data-at-modal='{"mode": "create"}'>
 *          jQuery Modal
 *      </button>
 *
 *  - Open a modal
 *      <button data-at-modal='{"mode": "open", "modal": "#MODAL_ID"}'>
 *          HTML Modal
 *      </button>
 *
 *      <div class="at-modal" id="MODAL_ID">
 *           <div class="at-modal-block">
 *              <figure class="at-modal-image">
 *                  <img src="http://wieisdemol.avrotros.nl/fileadmin/user_upload/widm_app_screenshots.jpg"/>
 *              </figure>
 *              <div class="at-modal-content">
 *                  <h1>Modal header</h1>
 *                  <p>Modal text ...</p>
 *               </div>
 *           </div>
 *       </div>
 *
 *  - Create a model using a lodash template
 *      <button data-at-modal='{"mode": "create", "template_modal": "#lodash-template-example"}'>
 *          jQuery modal powered by Lodash template
 *      </button>
 *
 *      <script type="text/template" id="lodash-template-example">
 *          <div class="<%= data.class.modal %>" id="<%= data.class.modal %>-<%= data.modal_id %>">
 *              <div class="at-modal-block">
 *                 Here some custom html...
 *              </div>
 *          </div>
 *      </script>
 *
 * Optional
 *  - Use event hook if modal is opening
 *      <script>
 *           $('#MODAL_ID').on('AtModal:onOpen', function() {
 *              alert('AtModal Event hook onOpen triggert');
 *           });
 *      </script>
 *
 *  - Use event hook if modal is closing
 *      <script>
 *           $('#MODAL_ID').on('AtModal:onClose', function() {
 *              alert('AtModal Event hook onClose triggert');
 *           });
 *      </script>
 *
 *   - Create modal on page load, and set a cookie (option cookie)
 *      <script>
 *            $(document).ready(function () {
 *                $('body').trigger('AtModal:Create', {
 *                    "mode": "create",
 *                    "template_modal": "#lodash-template-example",
 *                    "cookie": {
 *                        "key": 'at-modal-test-cookie'
 *                    }
 *                });
 *           });
 *       </script>
 *
 * Changelog
 *  - 1.1.3 alternative styling through the config
 *  - 1.1.2 build dependencies object in window.AtModal
 *  - 1.1.1 refactor history push state check with a check if the element has an attr href
 *  - 1.1.0 added escape keydown support for closing modal
 */

import AtModal from 'scripts/modules/modal';

window.At = window.At || {};

/**
 * Script version number to window object
 * @type {{version: string}}
 */
window.At.Modal = {
	version: '1.1.3',
	dependencies: {}
};

/**
 * DOM READY GO GO GO!!!
 */
$(() => {
	/**
	 * Travel through the DOM for data-at-modal attributes
	 * For each of the founded data attr create a new modal
	 */
	$('[data-at-modal]').each(AtModal.prototype._attach);

	/**
	 * Setup a jQuery chainable plugin for attaching to injected elements after page load
	 * @type {*}
	 */
	$.fn.AtModal = function () {
		$(this).each(AtModal.prototype._attach);
	};

	/**
	 * Set an custom event on the body for creating a new modal on page load
	 * (if triggered)
	 */
	$('body').on('AtModal:Create', (event, data) => {
		/**
		 * Create an unique id with timestamp
		 * @type {string}
		 */
		const $elementId = `at-modal-hidden-button-${Date.now()}`;

		/**
		 * Append a hidden button for bypass an trigger click event
		 */
		$('body').append($('<button />', {
			id: $elementId,
			text: 'hidden button',
			style: 'display:none;'
		}));

		const $element = $(`#${$elementId}`);

		new AtModal($element, data, 'load');
	});
});
